import { fromJS, List, Map } from 'immutable';
import * as actionTypes from './actionTypes';
import { createReducer } from 'utils/redux';

const initialState = new Map({
  declarations: List(),
  loading: true,
  error: null,
});

const onGetDeclarations = (state) => state.set('loading', true).set('error', null);

const onGetDeclarationsSuccess = (state, { payload }) =>
  state.set('loading', false).set('declarations', fromJS(payload));

const onGetDeclarationsError = (state, { payload }) =>
  state.set('loading', false).set('error', payload);

export default createReducer(initialState, {
  [actionTypes.GET_DECLARATIONS]: onGetDeclarations,
  [actionTypes.GET_DECLARATIONS_SUCCESS]: onGetDeclarationsSuccess,
  [actionTypes.GET_DECLARATIONS_FAILURE]: onGetDeclarationsError,
});
